import CustomButton from 'components/Buttons/CustomButton'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { confirmAdjustment, confirmTrx } from '../requestTransactionAction'
import { useNavigate } from 'react-router-dom'
import { CardText } from 'reactstrap'

const ButtonAction = ({ amount, code, data }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { linkApproved, isApproved } = useSelector((s) => s.reqTrxSell)

  useEffect(() => {
    if (linkApproved) {
      const url = new URL(linkApproved)
      const pathAndQuery = url.pathname + url.search

      navigate(pathAndQuery, { replace: true })
    } else if (isApproved && !linkApproved) {
      navigate('/confirmation-end', { replace: true })
    }
  }, [linkApproved, isApproved])

  return (
    <div className="d-flex align-items-center gap-2 w-100">
      {data?.orderStatus !== 'DISPUTE' &&
      data?.orderDetail?.type === 'BUY' &&
      data?.orderStatus !== 'NEW' &&
      (data?.approvedAt || isApproved) ? (
        <></>
      ) : (
        <>
          <CustomButton
            testId="order-reject-button"
            className="btn-cancel"
            color="secondary"
            block
            outline
            onClick={() => {
              if (
                data?.orderStatus === 'DISPUTE' &&
                data?.orderDetail?.type === 'BUY'
              ) {
                dispatch(confirmAdjustment({ code, agree: 'false' }))
              } else if (!data?.approvedAt) {
                dispatch(confirmTrx({ amount, code, status: 'CONFIRM' }))
              }
            }}
            disabled={
              data?.orderStatus !== 'DISPUTE' &&
              data?.orderStatus !== 'NEW' &&
              (data?.approvedAt || isApproved)
            }
          >
            Tolak
          </CustomButton>
          <CustomButton
            testId="order-accept-button"
            disabled={
              data?.orderStatus !== 'DISPUTE' &&
              data?.orderStatus !== 'NEW' &&
              (data?.approvedAt || isApproved)
            }
            block
            color="primary"
            onClick={() => {
              if (
                data?.orderStatus === 'DISPUTE' &&
                data?.orderDetail?.type === 'BUY'
              ) {
                dispatch(confirmAdjustment({ code, agree: 'true' }))
              } else if (!data?.approvedAt) {
                dispatch(confirmTrx({ amount, code, status: 'CONFIRM' }))
              }
            }}
          >
            {data?.orderDetail?.type === 'SELL' ? 'Terima dan Bayar' : 'Terima'}
          </CustomButton>
        </>
      )}
    </div>
  )
}

export default ButtonAction
